import { DEFAULT_CONSENT_OPTIONS } from '~/shared/constants/consent';
import type { ConsentParams } from '~/shared/types';

/**
 * Convert CookieConsent category list to the full GA consent object.
 * - analytics -> analytics_storage
 * - marketing -> ad_storage, ad_user_data, ad_personalization
 * - "necessary" is implied and does not toggle GA keys
 * // COOKIES: Leave it here in case we add these cookies in the future
 * //- functional -> functionality_storage, personalization_storage
 */
const mapCookieCategoriesToGaConsent = (
  categories: Array<string>,
): ConsentParams => {
  const base: ConsentParams = { ...DEFAULT_CONSENT_OPTIONS };

  if (categories.includes('analytics')) base.analytics_storage = 'granted';
  if (categories.includes('marketing')) {
    base.ad_personalization = 'granted';
    base.ad_storage = 'granted';
    base.ad_user_data = 'granted';
  }
  // COOKIES: Leave it here in case we add these cookies in the future
  // if (categories.includes('functional')) {
  //   base.functionality_storage = 'granted';
  //   base.personalization_storage = 'granted';
  // }

  return base;
};

export default mapCookieCategoriesToGaConsent;
